import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-calendar-icon',
  templateUrl: './calendar.component.html'
})
export class CalendarComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
